import React, { useState,useEffect } from 'react';
import { Box, RangeSlider, RangeSliderThumb, RangeSliderTrack, Tooltip, Button,Flex } from '@chakra-ui/react';
import { length, mapAccum, repeat, compose as C, last,map as m, of,addIndex, path,} from "ramda";
import { Form, Formik } from "formik";
import {useUpsertDataMutation,useUpdateDecisionMutation} from "../app/api";
import { useSelector } from 'react-redux';

  const checkAscendingOrder = (arr) => {
    for (let i = 0; i < arr.length - 1; i++) if (arr[i] > arr[i + 1]) return false;
    return true;
  };

export const Weighting = ({items,filtered,decision_id,participant_id,activity_id,order_nr,
  next_to_show,is_last,show_until,all_done}) => {
  const [upsertData] = useUpsertDataMutation();
  const [values, setValues] = useState([]);
  const [weights, setWeights] = useState();
  const [changed, setChanged] = useState(false);
  const texts = useSelector(path(["ui","ui_texts"]));

  const [moveForward] = useUpdateDecisionMutation();
  useEffect(() => {
    const default_values = C(last,mapAccum((a, b) => [a + b, a + b],0))(repeat(100/length(items),length(items)))
    const default_weights = repeat(Math.round(100/length(items)),length(items));
    const filtered_weights = filtered.map(x => x.value_number);
    const filtered_values = C(last,mapAccum((a, b) => [a+b,a+b],0))(filtered_weights);
    setValues(filtered.length ? filtered_values : default_values);
    setWeights(filtered.length ? filtered_weights : default_weights); 
  },[items,filtered])

  const handleSubmit = (x) => {
    C(
      upsertData,of,
      addIndex(m)((x,n) => ({
        value_number:x,
        ...(filtered.length ? {id:filtered[n].id} : {}),
        ...(items.length ? {input_id:items[n].id} : {}),
        decision_id,participant_id,activity_id
      }))
    )(weights)
    setChanged(false);
  }

  const handleChange = (xs) => {
    const lastValue = values[values.length - 1];
    
    if (checkAscendingOrder(xs)) {
      xs[xs.length - 1] = lastValue;
      setValues(xs);
      setChanged(true);
      setWeights(xs.map((x, n, xs) => Math.round(x - (n ? xs[n - 1] : 0))));
    }
  };
  return items && values?.length ? (<Box align="center" position="relative" style={{ minHeight: "20px"}}>
    <Formik 
        enableReinitialize={true} 
        initialValues={{inputs:values}} 
        onSubmit={handleSubmit}>
        {({ values}) => <Form>
        <RangeSlider 
          min={0} 
          max={100} 
          step={1} 
          onChange={(newValues) => handleChange(newValues)} 
          aria-label={['min', 'max']} 
          defaultValue={values.inputs}
        >
          <RangeSliderTrack />
          {values.inputs.map((value, index) => (
            <Tooltip hasArrow bg='teal.500' key={index} color='white' placement='top' label={items[index]?.value_text}>
              <RangeSliderThumb 
                index={index} 
                fontSize="sm" 
                boxSize={6} 
                children={weights[index]} 
              />
            </Tooltip>
          ))}
        </RangeSlider>
        <Flex mt={2} gap={2}>
          <Button
            size="md"
            colorScheme="teal"
            type="submit"
            isDisabled={!changed}
          >
            {texts.save}
          </Button>
          {(is_last || show_until > order_nr || !all_done) ? null : (
            <Button
              size="md"
              colorScheme="blue"
              onClick={() => {
                moveForward({
                  id: decision_id,
                  done: order_nr,
                  show_until:next_to_show
                });
              }}
            >
              {texts.next}
            </Button>
          )}  
        </Flex>
      </Form>}
    </Formik>
  </Box>
  ) : null;
};

export default Weighting;